import React from "react";

const StartWorkout = ({ short, basic, long }) => {
  return (
    <div className="opening-screen medium-width">
      <h2>
        Click a workout to get started!
      </h2>

      <button onClick={short}>
        30-minute Workout
      </button>
      <br/>
      <button onClick={basic}>
        60-minute Workout
      </button>
      <br/>
      <button onClick={long}>
        75-minute Workout
      </button>
    </div>
  )
}

export default StartWorkout;
